import { render, staticRenderFns } from "./AboutUsPart2.vue?vue&type=template&id=629236d5&scoped=true&"
import script from "./AboutUsPart2.vue?vue&type=script&lang=js&"
export * from "./AboutUsPart2.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsPart2.vue?vue&type=style&index=0&id=629236d5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629236d5",
  null
  
)

export default component.exports